import React from 'react';
import './TriBanner.css';

// const brandsByCountry = {
//     ARG: [
//         {
//             src: `${process.env.PUBLIC_URL}/banner/brands/marcasARGbannerweb.jpg`,
//             alt: 'MarcasVenta',
//         }
//     ]
// };

const MarcasVenta = () => {
    // const country = process.env.REACT_APP_COUNTRY;
    // const banners = brandsByCountry[country] || brandsByCountry.ARG;

    return null;
};

export default MarcasVenta;